import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";
import SimpleForm from "/components/SimpleForm";

export const ImageWithTextWithOverlay = ({
  className,
  sectionId,
  content,
  buttonTitle,
  buttons,
  image,
  popUpModal_1,
  dialog_content_1,
  popUpModal_1_form_id,
  successPageUrl,
  rowClass,
  backgroundColor,
  thumbnailLink
}) => {
  Fancybox.bind("[data-src]", {
    // Your custom options
  });
  return (
    <section
      id={sectionId}
      className={`${styles.root} ${className}`}
      style={{ background: backgroundColor ? "#ffffff" : "" }}
    >
      <Container>
        <Row
          className={`align-items-center ${
            rowClass ? "d-flex flex-row-reverse" : ""
          }`}
        >
          <Col md={5} className="left-column pe-md-5 mb-5 mb-md-0">
            {/* <img
              src={
                image?.url
                  ? image?.url
                  : "/site-assets/placeholders/img-placeholder.jpg"
              }
              width="100%"
              height="100%"
              alt={image?.alt}
              className="card-img rounded-4"
            /> */}
            {thumbnailLink ? (
              <a href={thumbnailLink} className="d-block">
                <img
                  src={
                    image?.url
                      ? image?.url
                      : "/site-assets/placeholders/img-placeholder.jpg"
                  }
                  width="100%"
                  height="100%"
                  alt={image?.alt}
                  className="card-img rounded-4"
                />
              </a>
            ) : (
              <img
                src={
                  image?.url
                    ? image?.url
                    : "/site-assets/placeholders/img-placeholder.jpg"
                }
                width="100%"
                height="100%"
                alt={image?.alt}
                className="card-img rounded-4"
              />
            )}
          </Col>
          <Col md={7} className="right-column ps-md-5">
            {content ? (
              <div className="mb-4">
                <div dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            ) : null}
            {popUpModal_1 && (
              <>
                <button
                  className="border-0 fancyBox primaryBtn no-arrow"
                  data-src={`#dialog-content-1`}
                >
                  {buttonTitle}
                </button>
              </>
            )}

            {buttons?.length > 0 && (
              <div className="mt-3 d-flex gap-2 flex-wrap">
                {buttons.map(({ id, url, label, className }) => (
                  <a key={id} href={url} className={className}>
                    {label}
                  </a>
                ))}
              </div>
            )}

            {popUpModal_1_form_id ? (
              <div class="dialog-content" id="dialog-content-1">
                <div>
                  {dialog_content_1 ? (
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: dialog_content_1,
                        }}
                      />
                      <hr></hr>
                    </>
                  ) : null}

                  <SimpleForm
                    formId={`${popUpModal_1_form_id}`}
                    successPageUrl={`${successPageUrl}`}
                  />
                </div>
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ImageWithTextWithOverlay;
